import _ from "lodash";
import { MaterialTableColumnProps } from "../../material-table/material-table";

export const PARTIES_FORM_ARRAY_NAME = 'parties';

export const PARTIES_FIELDS = {
    TYPE: 'account_type',

    FIRST_NAME: 'first_name',
    LAST_NAME: 'last_name',

    COMPANY_NAME: 'company_name',
    VAT_NUMBER: 'vat_number',
    CRN: 'crn',

    // COMPANY: 'company_id',
    COMPANY: 'companies',
    CURRENCY: 'currencies',
    CONTACT_NO: 'contact_no',
    EMAIL_IDS: 'email_ids',
    RESPONSIBLE_PERSON : 'responsible_person',

    ADDRESS: 'addresses',
    CONTACTS: 'contacts',

    RECEIVABLE_ACCOUNT: 'account_id',
    TAX_TEMPLATE: 'default_tax_template'
}

export const partyType = [
    { label: 'Individual', value: 'Individual' },
    { label: 'Company', value: 'Company' }
];

export const addressPayload = {
    parties_id: null,
    address_type: 'Office',
    contact_name: null,
    street_1: null,
    street_2: null,
    street_3: null,
    building_no: null,
    additional_no: null,
    zip_code: null,
    city: null,
    state: null,
    country: null,
    email: null,
    mobile: null,
    phone: null,
    summary: null,
    default_shipping_address: 0,
    default_billing_address: 0,
    country_code: null
};
export const ksaAddressPayload = {
    ...addressPayload,
    street_name: null,
    national_address: null,
    district_name: null,
};
export const contactPayload = {
    parties_id: null,
    name: null,
    country_code: null,
    contact_no: null,
    email: null
};

/* Address columns & rows */
export const addressColumns = (isKSA : boolean): MaterialTableColumnProps[] => [
    {
        header: 'common.party.table.addressType_header',
        accessorKey: 'address_type',
        visible: true,
        type: 'string',
        editVariant: 'select',
        editProperties: {
            placeholder: 'Select Address Type',
            field_name: 'address_type',
            defaultValue: 'Office',
            validations: [
                {
                    type: 'required',
                    value: true,
                    msg_en: 'Address Type is required',
                    msg_ar: 'Address Type is required'
                }
            ]
        },
        editSelectOptions: [
            { label: 'Delivery', value: 'Delivery' },
            { label: 'Shipping', value: 'Shipping' },
            { label: 'Office', value: 'Office' }
        ]
    },
    {
        header: 'common.party.table.addressee_header',
        accessorKey: 'contact_name',
        visible: true,
        type: 'custom_link',
        editProperties: {
            placeholder: 'Enter Addressee',
            field_name: 'contact_name',
            validations: [
                {
                    type: 'required',
                    value: false,
                    msg_en: 'Contact name is required',
                    msg_ar: 'Contact name is required'
                }
            ]
        }
    },
    {
        header: 'common.party.table.defaultShippingAddress_header',
        accessorKey: 'default_shipping_address',
        visible: true,
        type: 'custom_link',
        editVariant: 'checkbox',
        editProperties: {
            field_name: 'default_shipping_address'
        }
    },
    {
        header: 'common.party.table.defaultBillingAddress_header',
        accessorKey: 'default_billing_address',
        visible: true,
        type: 'custom_link',
        editVariant: 'checkbox',
        editProperties: {
            field_name: 'default_billing_address'
        }
    },
    {
        header: 'common.party.table.countryCode_header',
        accessorKey: 'country_code',
        visible: true,
        type: 'custom_link',
        enableEditing: false
    },
    {
        header: 'common.party.table.contactNumber_header',
        accessorKey: 'phone',
        visible: true,
        type: 'custom_link',
        editVariant: 'phone',
        editProperties: {
            field_name: 'phone'
        }
    },
    {
        header: 'common.party.table.addrressOne_header',
        accessorKey: 'street_1',
        visible: true,
        type: 'string',
        editProperties: {
            placeholder: 'Enter Address',
            field_name: 'street_1',
            validations: [
                {
                    type: 'required',
                    value: false,
                    msg_en: 'Address is required',
                    msg_ar: 'Address is required'
                }
            ]
        }
    },
    {
        header: 'common.party.table.addressTwo_header',
        accessorKey: 'street_2',
        visible: true,
        type: 'string',
        editProperties: {
            placeholder: 'Enter Address',
            field_name: 'street_2',
        }
    },
    {
        header: 'common.party.table.addressThree_header',
        accessorKey: 'street_3',
        visible: true,
        type: 'string',
        editProperties: {
            placeholder: 'Enter Address',
            field_name: 'street_3',
        }
    },
    ...(isKSA ? [
        {
            header: 'common.party.table.buildingNo_header',
            accessorKey: 'building_no',
            visible: true,
            type: 'string',
            editProperties: {
                placeholder: 'Enter Building No.',
                field_name: 'building_no',
                validations: []
            }
        },
        {
            header: 'common.party.table.additionalNo_header',
            accessorKey: 'additional_no',
            visible: true,
            type: 'string',
            editProperties: {
                placeholder: 'Enter Additional No.',
                field_name: 'additional_no',
                validations: []
            }
        },
        {
            header: 'common.party.table.streetName_header',
            accessorKey: 'street_name',
            visible: true,
            type: 'string',
            editProperties: {
                placeholder: 'Enter Street Name',
                field_name: 'street_name',
            }
        },
        {
            header: 'common.party.table.nationalAddress_header',
            accessorKey: 'national_address',
            visible: true,
            type: 'string',
            editProperties: {
                placeholder: 'Enter National Address',
                field_name: 'national_address',
            }
        },
        {
            header: 'common.party.table.districtName_header',
            accessorKey: 'district_name',
            visible: true,
            type: 'string',
            editProperties: {
                placeholder: 'Enter District Name',
                field_name: 'district_name',
            }
        },
    ] : []),
    {
        header: 'common.party.table.zipCode_header',
        accessorKey: 'zip_code',
        visible: true,
        type: 'string',
        editProperties: {
            field_name: 'zip_code',
            placeholder: 'Enter Zip Code',
        }
    },
    {
        header: 'common.party.table.country_header',
        accessorKey: 'country_name',
        visible: true,
        type: 'string',
        editVariant: 'select',
        editProperties: {
            field_name: 'country',
            placeholder: 'Select country',
            valueKey: 'country_id',
            apiType: 'countries',
            validations: [
                {
                    type: 'required',
                    value: true,
                    msg_en: 'Country is required',
                    msg_ar: 'Country is required'
                }
            ]
        }
    },
    {
        header: 'common.party.table.state_header',
        accessorKey: 'state_name',
        visible: true,
        type: 'string',
        editVariant: 'select',
        editProperties: {
            field_name: 'state',
            placeholder: 'Select state',
            valueKey: 'state_id',
            apiType: 'states',
            validations: [
                {
                    type: 'required',
                    value: true,
                    msg_en: 'State is required',
                    msg_ar: 'State is required'
                }
            ],
            customeFilter: (row: any, values) => {
                const countryFilter = values?.country_id ?? row?.original?.country_id;
                return countryFilter ? { '&country_id.eq': countryFilter } : null;
            }
        }
    },
    {
        header: 'common.party.table.city_header',
        accessorKey: 'city',
        visible: true,
        type: 'string',
        editProperties: {
            placeholder: 'Enter City',
            field_name: 'city',
            validations: []
        }
    },
    {
        header: 'common.party.table.summary_header',
        accessorKey: 'summary',
        visible: true,
        type: 'string',
        enableEditing: false
        // editProperties: {
        // 	placeholder: 'Populated after filling address',
        // 	field_name: 'summary'
        // 	disabled
        // }
    }
];

/* contact columns & rows */
export const contactColumns: MaterialTableColumnProps[] = [
    {
        header: 'common.party.table.name_header',
        accessorKey: 'name',
        visible: true,
        type: 'string',
        editProperties: {
            placeholder: 'Enter Name',
            field_name: 'name',
            validations: [
                {
                    type: 'required',
                    value: true,
                    msg_en: 'Name is required',
                    msg_ar: 'Name is required'
                }
            ]
        }
    },
    {
        header: 'common.party.table.email_header',
        accessorKey: 'email',
        visible: true,
        type: 'string',
        editProperties: {
            placeholder: 'Enter Email',
            field_name: 'email',
            validations: [
                {
                    type: 'required',
                    value: true,
                    msg_en: 'Email is required',
                    msg_ar: 'Email is required'
                },
                {
                    type: 'email',
                    value: true,
                    msg_en: 'Invalid Email',
                    msg_ar: 'Invalid Email'
                }
            ]
        }
    },
    {
        header: 'common.party.table.countryCode_header',
        accessorKey: 'country_code',
        visible: true,
        type: 'custom_link',
        enableEditing: false
    },
    {
        header: 'common.party.table.contactNumber_header',
        accessorKey: 'contact_no',
        visible: true,
        type: 'custom_link',
        editVariant: 'phone',
        editProperties: {
            field_name: 'contact_no'
        }
    }
];

export const addressOmitKeys = [
    'id',
    'state_id',
    'country_id',
    'country_name',
    'state_name',
    'parties_id',
    'state_data',
    'country_data',
    'summary'
];
export const contactOmitKeys = ['id', 'summary'];


export const processPartiesPayload = (payload: any) => {
    const { addresses = [], contacts = [], ...rest } = payload || {}
    const addressPayload = addresses.map(address => (_.omit(address, ...addressOmitKeys)))
    const contactPayload = contacts.map(contact => (_.omit(contact, ...contactOmitKeys)))
    return {
        ...rest,
        addresses: addressPayload,
        contacts: contactPayload
    }
}
